import React, {useState,useEffect} from 'react'
import {Form} from 'react-bootstrap'
import Api, {Get, Fetch} from '../Api'
import {ToNotify} from './ViewControl'


const InOption = ({member, entity, id, label, onChange, readOnly=false, options=[]}) => {
    const [message, Message] = useState('')
    const [loaded, Load] = useState(false)
    const [items, Items]= useState([])

    useEffect(() => {
        Get(`Option/${Api.defaults.domain}/${entity}`, Items, Load)
    }, [loaded])

    const onSelect=(e) =>{
        if(e?.target) {
            onChange && onChange(e)
            if(member>0 && id!==e.target.value) {
                //alert(`onSelect ${member},${entity} : ${e.target.name} value=${e.target.value} id=${id}`)
                Fetch('Option',{MemberId:member, OptionId:e.target.value},3,null,Message)                
            }
        }
    }
 
    return (
        loaded ? 
        <Form.Group className='form-row' style={{margin:'0.5rem 0', fontSize:'1.3rem'}}>

            <Form.Label className='col-sm-12' align='right'>:{label ?? entity}
            </Form.Label>

            <Form.Control as="select" name={entity+"Id"} className="text-right" onChange={onSelect} 
                value={id} readOnly={readOnly} disabled={readOnly} style={{fontSize:'1.3rem'}}>
                {
                    items.map(item => {
                        let id = item.Id.toString()
                        if(options.length===0 || options.includes(id))
                            return <option key={item.Id} value={item.Id} selected={id===item.Id}>{item.Value}</option>
                    }
                )

                }
            </Form.Control> 
        
            <ToNotify 
                message={message}
                onClose={()=>{Message('')}}
            />  
        </Form.Group> 
        
        : <div>{entity}s is loading...</div> 

        
    )
}

const InText = ({name,value='',label,type,size,onChange,readOnly=false}) => {

    return (
        <Form.Group controlId={`InText-${name}`} className='form-row conter'>
            
            <Form.Control
            className={ (name==='code') ? 'col-sm-8 text-center' : (name==='Phone')?'col-sm-12 text-center':'col-sm-12 text-right' }
            type={type ?? 'text'}
            name={name}                
            placeholder={label ?? name}
            defaultValue={value}
            style={{fontSize:size??'1.4rem', fontWeight:'bold', color:'blue', margin:'1rem auto'}}               
            readOnly={readOnly}
            onChange={onChange}
            //  required
            />
        </Form.Group>        
    )
}

const InDetail = ({name,value,label,readOnly,size,onChange, back, onKeyUp}) => {
    const Back = back ? `rgba(${back})` : 'transparent'
    //alert(Back)
    return (
        <textarea className="form-control" rows="2" 
            name={name} 
            type="text"
            style={{backgroundColor:Back, fontSize:size??'1.1rem', margin:'.3rem', overflowY: 'scroll', width:'100%' }}
            defaultValue={value ??''} 
            align='right'
            placeholder={label ?? name}
            readOnly={readOnly??false}  
            onChange={onChange} 
            onKeyUp={onKeyUp} 
        />
    )
}

/*
In React, components need to be capitalized !
*/
const InCheck = (name, value=false, mode=0, label) => {
    const [checked, setChecked] = React.useState(value)
    return (
        <div className="form-group form-row">
      <label className="control-label col-sm-2" style={{width:"auto", textAlign:"right"}}>
          {label ?? name}: </label>
          <div className="col-sm-1">
            <input type="checkbox" name={name}
            defaultChecked={checked}
            onChange={() => setChecked(!checked)}
            readOnly={(mode??0)===0}
            className="form-control" 
            />        
        </div>
      </div>     
    )
}

// MeR 251124 0001
const InVersion = ({version}) => {

    const onVersion = e => {
        e.preventDefault()
        let value=parseInt(e.target.value)
        document.cookie = `meVersion=${value}`
        //Version(value)        
    }

    return (
        version &&
        <select id="meVersion" title='رواية'
            onChange={onVersion}
            defaultValue={version}
        >
            <option value="1">ورش</option>
            <option value="2">حفص</option>
        </select>

    )
}

export {InVersion, InOption, InText, InDetail, InCheck}
